import React, { createContext, useEffect, useState } from 'react';
import {createUserWithEmailAndPassword,
sendPasswordResetEmail, 
updatePassword as updateFirebasePassword,
getAuth, onAuthStateChanged, 
signInWithEmailAndPassword, 
signInWithPhoneNumber, 
signOut, updateProfile,EmailAuthProvider,
reauthenticateWithCredential} from 'firebase/auth';


import { app1 } from '../firebase/firebase.config';

export const AuthContext = createContext();
const auth = getAuth(app1)

const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const createUser = (email, password) =>{
        setLoading(true);
        return createUserWithEmailAndPassword(auth, email, password);
    }

    const signIn = (email, password) =>{
        setLoading(true);
        return signInWithEmailAndPassword(auth, email, password);
    }

    const updateUser = (userInfo) =>{
        return updateProfile(auth.currentUser, userInfo);
    }

    const logOut = () =>{
        setLoading(true);
        return signOut(auth);
    }
    const signInWithPhone = (phoneNumber, appVerifier) => {
        setLoading(true);
        return signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      };
      const sendPasswordResetEmaill = (email) => {
        return sendPasswordResetEmail(auth, email);
      };

      const currentUser = () => {
        return auth.currentUser;
      };

      const changePasswordStudent = async (currentPassword, newPassword) => {
        if (!auth.currentUser) {
          throw new Error('No user is currently signed in');
        }
    
        // 1. Re-authenticate user
        const credential = EmailAuthProvider.credential(
          auth.currentUser.email,
          currentPassword
        );
    
        await reauthenticateWithCredential(auth.currentUser, credential);
    
        // 2. Once re-authenticated, update their password
        return updateFirebasePassword(auth.currentUser, newPassword);
      };
    
 

    useEffect( () =>{
        const unsubscribe = onAuthStateChanged(auth, currentUser =>{
            console.log('user observing');
            setUser(currentUser);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [])

    const authInfo = {
        createUser,
        signIn,
        updateUser,
        signInWithPhone,
        logOut,
        sendPasswordResetEmaill,
        changePasswordStudent,
        currentUser,
        user,
        loading
    }
    return (
        <AuthContext.Provider value={authInfo}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;